module.exports = __webpack_public_path__ + "static/media/kaioLingo.0e6c4128.png";